import { NewDatePickerProps } from "../typings";
import * as React from "react";
import {
  DayName,
  UitkNewDatePicker,
  UitkNewDatePickerTriggeredSelector
} from "uitk-react-new-date-picker";
import { LocalizedComponentClass, withLocalization } from "bernie-l10n";
import { observer } from "mobx-react";

const NewDatePickerComponent = observer((props: NewDatePickerProps) => {
  const dateFieldProps = {
    startId: UitkNewDatePickerTriggeredSelector.START,
    startLabel: props.l10n.formatText("datePicker.fromDate.label"),
    startPlaceholder: props.l10n.formatText("datePicker.dateInput.placeholder"),
    endId: UitkNewDatePickerTriggeredSelector.END,
    endLabel: props.l10n.formatText("datePicker.toDate.label"),
    endPlaceholder: props.l10n.formatText("datePicker.dateInput.placeholder"),
    showDatePicker: props.isOpen,
    dateFieldWrapperClasses: "uitk-cell s-cell-1-1 m-cell-1-3 l-cell-1-6 xl-cell-1-6",
    startInvalid: props.startInvalidMessage,
    endInvalid: props.endInvalidMessage,
    // tslint:disable-next-line
    routerLinkWrapper() {}
  };
  const firstDayOfWeek = parseInt(DayName[props.l10n.getWeekData().firstDay.toUpperCase()], 10);

  return (
    <UitkNewDatePicker
      doubleMonths={true}
      dateFieldProps={dateFieldProps}
      firstDayOfWeek={firstDayOfWeek}
      onOpenCB={props.onOpen}
      onDismissCB={props.onDismiss}
      onSubmitCB={props.onSubmit}
    />
  );
});

export const NewDatePicker: LocalizedComponentClass<NewDatePickerProps> = withLocalization(
  NewDatePickerComponent
);
